import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ISkillResource } from "../types";

export type ISkillDeleteMutationParameters = {
    skill: RelationalValue<ISkillResource>;
};

export type ISkillDeleteMutationResult = void;

export const skillDeleteMutation: IApiMutationFunction<ISkillDeleteMutationParameters> = ({ skill }) => {
    return {
        method: "DELETE",
        url: `/skills/${mapRelationalValue(skill)}`,
    };
};

export const useSkillDeleteMutation = createApiMutationHook<ISkillDeleteMutationParameters, ISkillDeleteMutationResult>(
    skillDeleteMutation,
);
